const CSS3Logo = ({ width = 75, height = 75 }) => {
    return (
      <svg
        width={width}
        height={height}
        viewBox="0 0 50 71"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_1342_2159)">
          <path
            d="M24.9686 70.3295L4.62051 64.6807L0.0859375 13.8213H49.9121L45.3728 64.6729L24.9686 70.3295Z"
            fill="#264DE4"
          />
          <path
            d="M41.4877 61.4351L45.3666 17.98H25V66.006L41.4877 61.4351Z"
            fill="#2965F1"
          />
          <path
            d="M10.4828 36.843L11.0418 43.0807H25.0006V36.843H10.4828ZM9.35938 24.2178L9.92637 30.4555H25.0006V24.2178H9.35938ZM25.0006 53.043L24.9732 53.0502L18.0264 51.1744L17.5822 46.1996H11.3205L12.1943 55.9937L24.9719 59.5406L25.0006 59.5328V53.043Z"
            fill="#EBEBEB"
          />
          <path
            d="M11.8125 0H19.3672V3.15938H14.9719V6.31875H19.3676V9.47793H11.8125V0ZM20.8783 0H28.4332V2.74727H24.0377V3.29668H28.4332V9.61543H20.8785V6.73047H25.274V6.18106H20.8781L20.8783 0ZM29.9443 0H37.4992V2.74727H33.1037V3.29668H37.4992V9.61543H29.9443V6.73047H34.3398V6.18106H29.9445L29.9443 0Z"
            fill="black"
          />
          <path
            d="M39.4781 36.843L40.6041 24.2178H24.9787V30.4555H33.7682L33.2006 36.843H24.9787V43.0807H32.6598L31.9355 51.1705L24.9785 53.0482V59.5377L37.7662 55.9937L37.86 54.9398L39.326 38.518L39.4781 36.843Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_1342_2159">
            <rect width="50" height="70.5078" fill="white" />
          </clipPath>
        </defs>
      </svg>
    );
  };
  
  export default CSS3Logo;
  